import { ArrowRight, Loader2 } from "lucide-react";
import { Button } from "@/frontend/components/ui/button";
import { useGetAppDeepLinkMutation } from "@/frontend/mutations/index";

export function MobileAppSection() {
  const getDeepLinkMutation = useGetAppDeepLinkMutation();

  return (
    <div className="mb-6">
      <h2 className="text-sm font-semibold mb-3">Sync your health apps</h2>
      <p className="text-sm text-muted-foreground mb-4">
        Download our app to automatically sync steps, heart rate, sleep, and other health data from Apple Health or Google Fit.
      </p>

      {/* Step 1: Download App */}
      <div className="mb-6">
        <div className="flex items-center gap-2 mb-3">
          <span className="w-6 h-6 rounded-full bg-primary text-primary-foreground text-sm font-medium flex items-center justify-center">1</span>
          <span className="font-medium text-sm">Download the app</span>
        </div>
        <div className="flex gap-3">
          <a
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 h-14 bg-black text-white rounded-lg flex items-center justify-center gap-2 hover:bg-black/90 transition-colors"
          >
            <svg className="w-8 h-8" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
            </svg>
            <div className="text-left">
              <p className="text-[10px] text-white/70 leading-none">Download on the</p>
              <p className="font-semibold text-sm leading-tight">App Store</p>
            </div>
          </a>
          <a
            href="#"
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 h-14 bg-black text-white rounded-lg flex items-center justify-center gap-2 hover:bg-black/90 transition-colors"
          >
            <svg className="w-6 h-6" viewBox="0 0 256 283">
              <path fill="#EA4335" d="M119.553 134.916L1.06 259.061a32.14 32.14 0 0 0 47.062 19.071l133.327-75.934z"/>
              <path fill="#FBBC04" d="M239.37 113.814L181.715 80.79l-64.898 56.95l65.162 64.28l57.216-32.67a31.345 31.345 0 0 0 0-55.537z"/>
              <path fill="#4285F4" d="M1.06 23.487A30.6 30.6 0 0 0 0 31.61v219.327a32.3 32.3 0 0 0 1.06 8.124l122.555-120.966z"/>
              <path fill="#34A853" d="m120.436 141.274l61.278-60.483L48.564 4.503A32.85 32.85 0 0 0 32.051 0C17.644-.028 4.978 9.534 1.06 23.399z"/>
            </svg>
            <div className="text-left">
              <p className="text-[10px] text-white/70 leading-none uppercase tracking-wide">Get it on</p>
              <p className="font-semibold text-sm leading-tight">Google Play</p>
            </div>
          </a>
        </div>
      </div>

      {/* Step 2: Connect the App */}
      <div>
        <div className="flex items-center gap-2 mb-3">
          <span className="w-6 h-6 rounded-full bg-primary text-primary-foreground text-sm font-medium flex items-center justify-center">2</span>
          <span className="font-medium text-sm">Connect the app</span>
        </div>

        <Button
          variant="outline"
          onClick={() => getDeepLinkMutation.mutate({})}
          disabled={getDeepLinkMutation.isPending}
          className="gap-2"
        >
          {getDeepLinkMutation.isPending ? (
            <Loader2 className="w-4 h-4 animate-spin" />
          ) : (
            <ArrowRight className="w-4 h-4" />
          )}
          Continue in app
        </Button>
      </div>
    </div>
  );
}
